import Vue from 'vue'
import Vuex from 'vuex'
import VuexI18n from 'vuex-i18n' // load vuex i18n module
import app from './modules/app'

import * as getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  getters,
  modules: {
    app,
  },
  state: {
    isLoggedIn: !!localStorage.getItem('token'),
    isLog: !!localStorage.getItem('situation'),
    // username: !!localStorage.getItem('username'),
    email: !!localStorage.getItem('email'),
    userData: {},

    // id: !!localStorage.getItem('id'),
  },
  mutations: {
    loginUser (state) {
      state.isLoggedIn = true
      state.isLog = true
      // state.email = true
    },
    logoutUser (state) {
      state.isLoggedIn = false
      state.isLog = false
      localStorage.removeItem('userType')
      localStorage.removeItem('userName')
      // state.email = false
    },
    userData (state, item) {
      state.userData = item
    },
  },
})

Vue.use(VuexI18n.plugin, store)

export default store
